const TYPE = "D2D";

/** Setup **/
export const CREATE_INTERFACE_INFO = `${TYPE}_create_interface_info`;

export const GET_CHANNEL_INFO = `${TYPE}_get_channel_info`;
export const UPDATE_CHANNEL_INFO = `${TYPE}_update_channel_info`;
export const UPDATE_STATUS = `${TYPE}_update_status`;
export const UPDATE_LOADING = `${TYPE}_update_loading`;

export const UPDATE_ALL_CONTENT = `${TYPE}/update_all_content`;

// Signal table
export const UPDATE_SIGNAL_NAME = `${TYPE}/update_signal_name`;
export const UPDATE_SIGNAL_NETS = `${TYPE}/update_signal_nets`;
export const DELETE_SIGNAL_NET = `${TYPE}/delete_signal_net`;
export const ADD_SIGNAL_NET = `${TYPE}/add_signal_net`;
export const UPDATE_SIGNAL_GROUP = `${TYPE}/update_signal_group`;

/* table */
export const EDIT_COMPONENT_PIN_TABLE = `${TYPE}/edit_component_pin_table`;
export const SAVE_PIN_MODEL = `${TYPE}/save_pin_model`;
export const SAVE_POWER_OFF = `${TYPE}/save_power_off`;
export const SAVE_MODEL_PINS = `${TYPE}/save_model_pins`;
export const SAVE_STIMULUS = `${TYPE}/save_stimulus`;
export const STIMULUS_RANDOM = `${TYPE}/stimulus_random`;
export const EDIT_SAME_TYPE_COMPONENT_PIN_TABLE = `${TYPE}/edit_same_type_component_pin_table`;

export const SAVE_D2D_CONTENT_TO_SERVER = `${TYPE}save_d2d_content_to_server`;

/**  Top **/
export const SAVE_EXTRACTION_INFO = `${TYPE}_save_extraction_info`;
export const SAVE_PORT_SETUPS = `${TYPE}/save_port_setups`;
export const SAVE_REFERENCE_NETS = `${TYPE}/save_reference_nets`;

export const CONFIG_OPERATION = `${TYPE}/config_operation`;

export const UPDATE_EXPANDED_GROUP = `${TYPE}/update_expanded_group`;

export const EDIT_COMPONENT_TABLE = `${TYPE}/edit_component_table`;
export const UPDATE_COMPLIANCE = `${TYPE}/update_compliance`;

export const UPDATE_IS_EDITING = `${TYPE}/update_is_editing`;

export const UPDATE_PINS_EXPANDED_GROUP = `${TYPE}/update_pins_expanded_group`;